import { photoUrlBase } from '../constants';

type GetFullPhotoUrl = (baseUrl: string) => string;

export const getPhotoUrl: GetFullPhotoUrl = baseUrl =>
	baseUrl.includes('https') ? baseUrl : `${photoUrlBase}${baseUrl}`;

type GetPopupPhotoUrl = (baseUrl: string) => string;
export const getPopupPhotoUrl: GetPopupPhotoUrl = baseUrl => {
	switch (baseUrl) {
		case `${photoUrlBase}/M7oyyXULdkeLpDoAcRhKow/services-platform-regional-landing-ustanovka-dveri.jpg`:
			return `${photoUrlBase}/BT3BCJcSIUmnJm9phT7Lbg/services-platform-regional-landing-ustanovka-dveri-popup.jpg`;
		case `${photoUrlBase}/05q1mLYEiUWDYoiO6R68Kg/services-platform-regional-landing-ustanovka-garderobnyh-sistem.jpg`:
			return `${photoUrlBase}/KauZSVZhDEq-W7Tf3KLMCA/services-platform-regional-landing-ustanovka-garderobnyh-sistem-popup.jpg`;
		case `${photoUrlBase}/wuPqsmmYbECe2dqjs8UKTA/services-platform-regional-landing-ustanovka-kuhon.jpg`:
			return `${photoUrlBase}/EcphZzZ_GkuSz9i8VpLqaA/services-platform-regional-landing-ustanovka-kuhon-popup.jpg`;
		default:
			return `${baseUrl.slice(0, baseUrl.indexOf('.jpg'))}-popup.jpg`;
	}
};
